<script setup lang="ts">
import { MeasureResult } from '@Shared/utils/types';
import Gauge from './parts/Gauge.vue';
import { calculateDeltaValue, DeltaType, MetricType } from './utility';

const props = defineProps<{
  metricValue: MeasureResult;
  numberOfFilteredResponses?: number;
  countTitle: string;
  title: string;
  metricType: MetricType;
}>();

const delta = computed(() => calculateDeltaValue(props.metricValue, DeltaType.PointDelta));
</script>
<template>
  <div class="h-full flex flex-col bg-[#F9FAFB] rounded-[8px]" id="GaugeChart">
    <div
      class="ml-4 mb-2 mt-2 mr-4 w-[100%] font-bold xl:text-4 2xl:text-5 3xl:text-10 text-lg 2xl:mt-4 2xl:ml-6 3xl:mt-8 3xl:ml-10 font-family[Poppins] text-[#4F4F4F]"
    >
      {{ title }}
    </div>
    <Gauge
      class="w-100% mt-auto mb-auto"
      :delta="delta"
      :value="metricValue.currentValue"
      :metricType="metricType"
    ></Gauge>
    <div
      class="rounded-[4px] mt-2 ml-4 mr-4 mb-4 bg-[#CCD1D8] xl:text-5 2xl:text-7 3xl:text-12 text-center text-[#333333] 2xl:ml-6 2xl:mr-6 2xl:mt-4 2xl:mb-6 3xl:mt-10 3xl:mr-12 3xl:ml-12 3xl:mb-8 3xl:rounded-[8px]"
    >
      <div class="inline-block font-bold">
        {{ numberOfFilteredResponses ?? 0 }}
      </div>
      <div class="inline-block ml-2 3xl:ml-4">
        {{ countTitle }}
      </div>
    </div>
  </div>
</template>
